// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("iconfont.eot?t=1553568091071", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:application/x-font-woff2;charset=utf-8;base64,d09GMgABAAAAAAOsAAsAAAAACGAAAANeAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHEIGVgCDHAqEJINQATYCJAMQCwoABCAFhG0HQBs6BxHVm5nIfhzkZplLngZ/IsVFJzlp+jl4HnPq+5acuFLSASG5HTAn4zMAFWiIt52zueaAjYqafJKz6NEXkvYxvXxGAfA/x0xXJZAfaG4ZpaO9AY5bBxTVNMADCqAD4lsOZ16FR9dpCGAoSmWkddvOvfHQkEkCyOQJ40bgpTTomnzBQwiUrNTIFlw8Z63zlAmb/d+X31TigYOrIGd1H9tmNM2/qW/tlB/zBysffzwTIK4DBVQGNMj4UstIVBipjMLo/TV1AQ8PB8bqaP2tXSyGeXuReFRC3388ByQAyQ0BUBt8Cr7ZnFjaGlQISNtBDg7AC1nhAbmAKPAYQimMKEDdQa00cNx9K4fi8obCYZtDsiunX5+whMaSQ4b7IsdGjnKN7KMG11S6RV9uUfYTV/PrvdfKhNfvTthlQut2iZuw2+ZYvxPt7zBm3Q5/p7WnbxRy910ffiyl7d2k4keT2zxI7bv/xvpr/tV11/skJfX2d67fLcdT291LLhG5U1L62aFMec2OruLeCj8pH1HClvfy6UNK30jkbFK0T7R3rE+fSCxMJ9o3SlJE++aySKRvpCJ9iFbs2SDxb/VLtWx/W+vSMvs271u7LLAm0N9GVvd1M29NSe8Pe+O72Vpf/uk2ratXB4JWhBo1grdrxa9tShFrStvN7yVTp0ov0zTJFO15e/kSS4om5kivqVMztibat3neHkk84maED9m3NstCZFnC84wvyZO3kiA1lK+wLd35+6//hrdJnzKGZWv837MagLQbVwZBlkYBP4zbmvtnuS0rtMEnWq01gc0xczVLCMIryjMY4H8mICfvxpDlaZ0LgkeeGByCFAGFR2mkxlYGF0ttCODRDAyVaLfekouZKETHARVZiUDIzkVwiOcGKLLzDKmxb8ElL38hQHZRYOgruXa0Pnupd0dBo+jB/qF2PBDT6y7Iv2F4d0aSfJ/6QhlrP5RZkY1fcUAZY874CZUqAQn3cEHnYdcxJOEGnWZRNR3ynMo+lDnuJzuOgkbRA/YP1I4HcmvrLvfzNwzvzkhNWZ31hTLW3QMlGUUL5FUytCq7lnfGT6hQJYCEe+CCTNjRCAOpfFiDTjNij1A6kONq1FaSzS/rn3AdYCCPanFEiRaX5cw6RF10SLpmotqhTCYAAA==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("iconfont.woff?t=1553568091071", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("iconfont.ttf?t=1553568091071", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("iconfont.svg?t=1553568091071", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#iconfont" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {font-family: "iconfont";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* IE9 */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'), /* IE6-IE8 */
  url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+ */
  url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('svg'); /* iOS 4.1- */
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.el-icon-ipf-right:before {
  content: "\\e644";
}

.el-icon-ipf-left:before {
  content: "\\e647";
}

.el-icon-ipf-officer:before {
  content: "\\e603";
}

`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
